import { Entry } from '../Entry'

export function Entry20240805() {
  return (
    <Entry title="05/08/2024 - v3.7.10">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16007/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
